var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F8FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.3V18.2H22.6C22.8 18.2 22.9 18.4 22.9 18.6L22.5 20.5C22.5 20.6 22.3 20.7 22.2 20.7H20V28H17V20.8H15.3C15.1 20.8 15 20.7 15 20.5V18.6C15 18.4 15.1 18.3 15.3 18.3H17V15C17 13.3 18.3 12 20 12H22.7C22.9 12 23 12.1 23 12.3V14.7C23 14.9 22.9 15 22.7 15H20.3C20.1 15 20 15.1 20 15.3Z",
    stroke: "#004AA8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28H15C10 28 8 26 8 21V15C8 10 10 8 15 8H21C26 8 28 10 28 15V21C28 26 26 28 21 28Z",
    stroke: "#004AA8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3f394dde4a432b28a297022de0d98433.svg";
export { ForwardRef as ReactComponent };